<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Kgg0mh/tc-custom/9781909166301.jpg?1703706238851" alt="This image is the cover for the book Footprints on the Sands of Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Footprints on the Sands of Time
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of RAF Evaders provides a comprehensive reference of the airmen of Bomber Command who were held in German captivity during WWII.</b><br/><br/> This extensive book is divided into two part. The first, which has eighteen chapters, deals with German POW camps as they were opened, in chronological order and to which the Bomber Command POWs were sent. Each chapter includes anecdotes and stories of the men in the camps—capture, escape, illness, and murder—and illustrates the awfulness of captivity even in German hands. Roughly one in every twenty captured airmen never returned home.<br/><br/> The first part also covers subjects such as how the POWs were repatriated during the war; how they returned at war’s end; the RAF traitors; the war crimes; and the vital importance of the Red Cross. The style is part reference, part gripping narrative, and the book will correct many historical inaccuracies, and includes previously unpublished photographs.<br/><br/> The second part comprises an annotated list of ALL 10, 995 RAF Bomber Command airmen who were taken prisoner, together with an extended introduction.<br/><br/> The two parts together are the fruit of exhaustive research and provide an important contribution to our knowledge of the war and a unique reference work not only for the serious RAF historian but for the ex-POWs themselves and their families and anyone with an interest in the RAF in general and captivity in particular.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Oliver Clutton-Brock
      </h2>
      
      <p class="authorDescription body article">Oliver Clutton-Brock, born in London three weeks before the end of the Second World War, spent the first 17 years of his life in Lincoln, surrounded by many of Bomber Command&rsquo;s now historic airfields. Early aviation memories are of four-engined aircraft always flying overhead, searchlights, and a trip in a DH Rapide from RAF Scampton on Battle of Britain Day sometime in the fifties.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?84fa9406